var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"m-md",attrs:{"id":"conditions"}},[_c('h1',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.$t('eurofiscalis_workers.register.conditions.title')))]),_vm._v(" "),_c('div',{staticClass:"m-t-md",domProps:{"innerHTML":_vm._s(_vm.$t('eurofiscalis_workers.register.conditions.content'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }